<template>
  <div class="main">
    <div class="main-desc">
      <div>
        <el-image :src="require('../assets/image/desc.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
      </div>
      <div>
        <el-image :src="require('../assets/image/map.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
      </div>
      <div>
        <el-button class="btn" :type="activeArea == 'cq' ? 'primary' : ''" round size="small" @click="handleAreaClick('cq')">重庆市</el-button>
        <el-button class="btn" :type="activeArea == 'hn' ? 'primary' : ''" round size="small" @click="handleAreaClick('hn')">湖南省</el-button>
        <el-button class="btn" :type="activeArea == 'hb' ? 'primary' : ''" round size="small" @click="handleAreaClick('hb')">湖北省</el-button>
        <el-button class="btn" :type="activeArea == 'gj' ? 'primary' : ''" round size="small" @click="handleAreaClick('gj')">贵州省</el-button>
        <span class="beian">网站备案号：渝ICP备2024032881号-1</span>
      </div>
    </div>
    <div class="main-con">
      <div class="main-con-box">
        <el-image :src="require('../assets/image/imgyud.jpg')" fit="contain" :class="['main-img', activeArea == '' ? '' : 'hide']">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
        <video ref="videocq" muted :class="['video', activeArea == 'cq' ? 'show' : '']">
          <source :src="require('../assets/video/cq.mp4')" type="video/mp4" />
        </video>
        <video ref="videogj" muted :class="['video', activeArea == 'gj' ? 'show' : '']">
          <source :src="require('../assets/video/gj.mp4')" type="video/mp4" />
        </video>
        <video ref="videohb" muted :class="['video', activeArea == 'hb' ? 'show' : '']">
          <source :src="require('../assets/video/hb.mp4')" type="video/mp4" />
        </video>
        <video ref="videohn" muted :class="['video', activeArea == 'hn' ? 'show' : '']">
          <source :src="require('../assets/video/hn.mp4')" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import {EventBus} from '../utils/eventBus.js'
export default {
  name: 'Yu',
  data() {
    return {
      activeArea: ''
    }
  },
  methods: {
    handleAreaClick(area) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      this.activeArea = area
      this.$refs['video' + area].play()
    }
  }
}
</script>
<style lang="scss">
.main {
  display: flex;
  height: 100%;
  .main-img {
    width: 100%;
  }
  .main-desc {
    width: 360px;
    max-height: 1000px;
    padding-top: 60px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .main-con {
    flex: 1;
    padding-left: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    .main-img {
      height: 100%;
      min-height: 50%;
    }
    .hide.main-img {
      visibility: hidden;
    }
    .main-con-box {
      position: relative;
      height: 100%;
      .video {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        visibility: hidden;
      }
      .video.show {
        visibility: visible;
      }
    }
  }
}

@media screen and (max-height: 768px) {
  .main-desc {
    width: 330px;
  }
}
</style>

<style lang="scss" scoped>
.btn {
  width: 80px;
}
</style>
